var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.alerts.data),function(el,index){return _c('Notification',{key:((el.description) + "-" + index),attrs:{"element":el,"close":_vm.alerts.onClose}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }